import { render } from "./V2CampaignActivities.vue?vue&type=template&id=29dfa652&scoped=true"
import script from "./V2CampaignActivities.vue?vue&type=script&lang=js"
export * from "./V2CampaignActivities.vue?vue&type=script&lang=js"

import "./V2CampaignActivities.vue?vue&type=style&index=0&id=29dfa652&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dfa652"]])

export default __exports__